module.exports = __webpack_public_path__ + "static/media/location.84b8f6ae.svg";